import React from "react";

interface GradientAvatarProps {
    name: string;
    size?: number;
    className?: string;
}

/* Brand-aligned gradient palette */
const GRADIENTS = [
    "linear-gradient(135deg, #035DB8 0%, #024D9A 100%)",
    "linear-gradient(135deg, #0284C7 0%, #0369A1 100%)",
    "linear-gradient(135deg, #059669 0%, #047857 100%)",
    "linear-gradient(135deg, #7C3AED 0%, #6D28D9 100%)",
    "linear-gradient(135deg, #D97706 0%, #B45309 100%)",
    "linear-gradient(135deg, #0891B2 0%, #0E7490 100%)",
];

const GradientAvatar: React.FC<GradientAvatarProps> = ({ name, size = 32, className = '' }) => {
    const safeName = name || '?';
    const gradient = GRADIENTS[safeName.charCodeAt(0) % GRADIENTS.length];
    const parts = safeName.trim().split(/\s+/).filter(Boolean);
    const initials = parts.length === 0
        ? "?"
        : parts.length >= 2
            ? (parts[0][0] + parts[1][0]).toUpperCase()
            : parts[0][0].toUpperCase();

    const fontSize = size <= 32 ? 'text-xs' : size <= 40 ? 'text-sm' : 'text-base';

    return (
        <div
            className={[
                'flex items-center justify-center rounded-full font-bold text-white',
                'ring-[1.5px] ring-white/80 dark:ring-surface-dark shadow-[0_2px_8px_-2px_rgba(0,0,0,0.2)]',
                fontSize,
                className,
            ].join(' ')}
            style={{ width: size, height: size, background: gradient }}
        >
            {initials}
        </div>
    );
};

export default GradientAvatar;
